import { usePasswordField } from "@/shared/composables/usePasswordField.composable";
import { useForm } from "vee-validate";

export const usePasswordFormFields = () => {
  const { handleSubmit } = useForm();
  const { password, possibleErrors: possiblePasswordErrors } =
    usePasswordField();

  return {
    handleSubmit,
    possiblePasswordErrors,
    password,
  };
};
